module.exports = __webpack_public_path__ + "img/star.2134c908.svg";